import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Route, UrlSegment, Router } from '@angular/router';
import { AuthenticationService, FamilyService, SnackbarService } from '@app/services';
import { Role } from '@app/models/user';

@Injectable()
export class VariousGuard {

  constructor(
    private authService: AuthenticationService,
    private familyService: FamilyService,
    private snackbarServive: SnackbarService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAccess(route, state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAccess(route, state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.checkAccess(route, segments.join('/'));
  }

  checkAccess(route: Route | ActivatedRouteSnapshot, redirectUrl?: string): boolean {


    if (route.data) {
      // Some routes cannot be accessed if user come from OIDC
      if (route.data.notFromOIDC && this.authService.currentUserValue.fromOIDC) {
        return false;
      }

      // Prevent admin access to user parts
      if (route.data.notForManager && this.authService.currentUserValue.role !== Role.User) {
        this.snackbarServive.info('Réservé aux usagers')
        if (this.authService.hasRole(Role.Manager)) {
          this.router.navigate(['/admin']);
        }
        return false;
      }

      // Routes (ex: mandats SEPA) requiring a valid usager account linked to a family
      if (route.data.validFamilyAccount) {
        const user = this.authService.currentUserValue;
        if (!user || user.idAdulte < 1 || this.familyService.currentFamily?.id < 1) {
          this.snackbarServive.info('Accès refusé : votre compte doit être validé par nos services.');
          this.router.navigate(['/account']);
          return false;
        }
      }

    }

    return true;
  }

}


